import { render, staticRenderFns } from "./popPushInput.vue?vue&type=template&id=16152410&scoped=true&"
import script from "./popPushInput.vue?vue&type=script&lang=js&"
export * from "./popPushInput.vue?vue&type=script&lang=js&"
import style0 from "./popPushInput.vue?vue&type=style&index=0&id=16152410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16152410",
  null
  
)

export default component.exports